import React from 'react';
import { BrainCircuit, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AiAssistantButton = ({ onClick, isLoading, title, className = '', disabled = false, size = 16 }) => {
    const { t } = useTranslation();

    return (
        <button
            onClick={onClick}
            disabled={disabled || isLoading}
            className={`flex items-center justify-center p-1.5 bg-indigo-100 text-indigo-700 rounded-md hover:bg-indigo-200 transition-colors border border-indigo-200 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
            title={title || t('aiAssistant.title', 'Assistant ACG')}
            type="button"
        >
            {isLoading ? (
                <RefreshCw size={size} className="animate-spin" />
            ) : (
                <BrainCircuit size={size} />
            )}
        </button>
    );
};

export default AiAssistantButton;
